import { Environment, EnvironmentName } from 'src/app/core/models/environment.models';

export const environment: Environment = {
  name: EnvironmentName.DEV,
  apiUrl: 'https://dev-scribbly.wlcmapps.com',
  socketUrl: 'wss://dev-scribbly.wlcmapps.com',
};
